// Transcribed verbatim from the client's V2 document, punctuation included: curly quotes
// and apostrophes, the en dash in `50–70%`, `CO₂`, the comma splice in "takes a lot of
// energy, producing just one kilogram", the double space in "used in  manufacturing", and
// `Welcome to iPhone` alone in carrying no full stop. Don't tidy any of it.
//
// Two mechanical concessions, both so the card can render what the prose used to only say:
// the client's Location column is lifted out to `place` (it used to lead the body behind an
// em dash), and each body's trailing citation group to `citations`. Nothing else moves.
//
// Two keys here no longer echo their stop's slug, and that is deliberate: `extractionPoboya`
// is the stop the URL calls `extraction-2`, and `refiningSwiss` the one it calls `refining`,
// kept from when gold had two refining beats. An id follows its *beat*, not its slug and not
// its position — these strings are already in Lokalise, and renaming a key to tidy it would
// throw away the translation attached to it.
export default {
  label: {
    id: 'rm_journey_environmental_label',
    defaultMessage: 'Mine its Environmental Impact',
  },

  introLabel: {
    id: 'rm_journey_environmental_intro_label',
    defaultMessage: 'Intro',
  },
  introTitle: {
    id: 'rm_journey_environmental_intro_title',
    defaultMessage: 'Gold’s environmental impact',
  },
  introBody: {
    id: 'rm_journey_environmental_intro_body',
    defaultMessage:
      'Gold’s conductivity and resistance to corrosion make it ideal for the tiny connections linking chips, circuit boards and camera sensors inside your phone.',
  },
  introBodyTwo: {
    id: 'rm_journey_environmental_intro_body_two',
    defaultMessage:
      'From extraction to manufacture to sale, trace the environmental impact of gold across the planet.',
  },
  introCta: {
    id: 'rm_journey_environmental_intro_cta',
    defaultMessage: 'Next',
  },

  extractionLabel: {
    id: 'rm_journey_environmental_extraction_label',
    defaultMessage: 'Extraction',
  },
  extractionTitle: {
    id: 'rm_journey_environmental_extraction_title',
    defaultMessage: 'Moving mountains, destroying rivers.',
  },
  extractionPlace: {
    id: 'rm_journey_environmental_extraction_place',
    defaultMessage: 'Grasberg gold mine, Tembagapura, Indonesia',
  },
  extractionBody: {
    id: 'rm_journey_environmental_extraction_body',
    defaultMessage:
      'In the Aikwa River system, fish have nearly disappeared. Grasberg’s tailings and acid rock drainage have destroyed aquatic life and disrupted food chains. Forests cleared for gold mining have some of the slowest recovery rates, leaving the land effectively dead for decades.',
  },
  extractionCta: {
    id: 'rm_journey_environmental_extraction_cta',
    defaultMessage: 'Next',
  },

  extractionPoboyaLabel: {
    id: 'rm_journey_environmental_extraction_poboya_label',
    defaultMessage: 'Extraction II',
  },
  extractionPoboyaTitle: {
    id: 'rm_journey_environmental_extraction_poboya_title',
    defaultMessage: 'Spinning raw material into gold.',
  },
  extractionPoboyaPlace: {
    id: 'rm_journey_environmental_extraction_poboya_place',
    defaultMessage: 'Poboya Gold Mine, Palu City, Indonesia',
  },
  extractionPoboyaBody: {
    id: 'rm_journey_environmental_extraction_poboya_body',
    defaultMessage:
      'Industrial gold extraction can produce acidic water loaded with arsenic, cadmium, mercury and lead, contaminating rivers and groundwater for thousands of years. Artisanal miners burn off mercury used to bind gold, making gold mining the world’s largest source of intentional mercury pollution.',
  },
  extractionPoboyaCta: {
    id: 'rm_journey_environmental_extraction_poboya_cta',
    defaultMessage: 'Next',
  },

  refiningSwissLabel: {
    id: 'rm_journey_environmental_refining_swiss_label',
    defaultMessage: 'Refining',
  },
  refiningSwissTitle: {
    id: 'rm_journey_environmental_refining_swiss_title',
    defaultMessage: 'Creating the gold standard.',
  },
  refiningSwissPlace: {
    id: 'rm_journey_environmental_refining_swiss_place',
    defaultMessage: 'Mendrisio, Switzerland',
  },
  refiningSwissBody: {
    id: 'rm_journey_environmental_refining_swiss_body',
    defaultMessage:
      'Turning gold pure enough for your phone takes a lot of energy, producing just one kilogram of gold generates an estimated 12,500 kilograms of CO₂ equivalent. Much of this happens in Switzerland, as they refine 50–70% of the world’s gold, despite producing none of it.',
  },
  refiningSwissCta: {
    id: 'rm_journey_environmental_refining_swiss_cta',
    defaultMessage: 'Next',
  },

  manufactureLabel: {
    id: 'rm_journey_environmental_manufacture_label',
    defaultMessage: 'Manufacture',
  },
  manufactureTitle: {
    id: 'rm_journey_environmental_manufacture_title',
    defaultMessage: 'Gold becomes a phone.',
  },
  manufacturePlace: {
    id: 'rm_journey_environmental_manufacture_place',
    defaultMessage: 'Guangdong Province, China',
  },
  manufactureBody: {
    id: 'rm_journey_environmental_manufacture_body',
    defaultMessage:
      'Gold is used in  manufacturing circuit boards. This process generates wastewater that can contain heavy metals, forever chemicals and other pollutants, harming ecosystems when discharged.',
  },
  manufactureCta: {
    id: 'rm_journey_environmental_manufacture_cta',
    defaultMessage: 'Next',
  },

  saleLabel: {
    id: 'rm_journey_environmental_sale_label',
    defaultMessage: 'Sale',
  },
  saleTitle: {
    id: 'rm_journey_environmental_sale_title',
    defaultMessage: 'Welcome to iPhone',
  },
  salePlace: {
    id: 'rm_journey_environmental_sale_place',
    defaultMessage: 'Apple Flagship Store, NYC, USA',
  },
  saleBody: {
    id: 'rm_journey_environmental_sale_body',
    defaultMessage:
      'You buy an iPhone containing gold extracted from mines that have left behind scarred landscapes, dead rivers, and uninhabitable forests.',
  },
  saleCta: {
    id: 'rm_journey_environmental_sale_cta',
    defaultMessage: 'Go deeper on Gold',
  },
} as const
